import {
  Id,
  Identifiable,
  Resource,
  ResourceTypes,
  Role,
  Tag,
} from "@planzone/dto";
import { Filter as F } from "@planzone/dto";

type Filter = F & {
  resourceTypes: ResourceTypes[];
  roles: Identifiable<Role>[];
  areSortedByGroups: boolean;
  inactiveOnly: boolean;
  // Saved filters from before have none.
  activeOnly?: boolean;
};

enum SortOption {
  Default = "planzoneMembersPage.sorters.default",
  NAME = "planzoneMembersPage.sorters.name",
  Role = "planzoneMembersPage.sorters.role",
  CreationDate = "planzoneMembersPage.sorters.creationDate",
}

type SortFunctions = {
  [key in SortOption]: (
    data: Identifiable<Resource>[],
  ) => Identifiable<Resource>[];
};

interface Props {}

export type { Props, Filter, SortFunctions };

export { SortOption };
